import { api } from './networkService';

class DashboardService {
    static async fetchDashboard(filters) {
        try {
            const response = await api.get(`api/user/dashboard`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch dashboard error:', error);
            throw error;
        }
    }
}

export default DashboardService;
